<div class="breadcrumbGlobal">
    <a [routerLink]="['/mydashboard']">
        <mat-icon>home</mat-icon>
    </a>
    <mat-icon>chevron_right</mat-icon>
    <a [routerLink]="['/store/subscription-account']"><span translate>SUBSCRIPTIONS_ACCOUNTS.SUBSCRIPTIONS_ACCOUNTS_MANAGEMENT</span></a>
    <mat-icon>chevron_right</mat-icon>
    <a [routerLink]="['/magoweb-management/magoweb-dashboard']"><span translate>PRODUCT_CONFIGURATION</span></a>
    <mat-icon>chevron_right</mat-icon>
    <span translate>INDUSTRY_CONFIGURATOR.SUBSCRIPTION_CONFIGURATION</span>
</div>
<tb-header
    parentPage="magowebmanagement"
    [quotationOrIndustryDescri]="this.subscriptionDescription"
    *ngIf="!this.magoWebService?.isModifyStatus && !this.magoWebService?.subscriptionNfs"
></tb-header>
<tb-header
    parentPage="magowebmanagementmodify"
    [quotationOrIndustryDescri]="this.subscriptionDescription"
    *ngIf="this.magoWebService?.isModifyStatus && !this.magoWebService?.subscriptionNfs"
></tb-header>
<tb-header
    parentPage="magowebmanagement"
    [quotationOrIndustryDescri]="this.subscriptionNFS"
    *ngIf="this.magoWebService?.subscriptionNfs"
></tb-header>

<div class="contentGlobal" style="text-align: left">
    <mat-drawer-container>
        <mat-drawer-content>
            <div [ngClass]="this.smallScreen ? 'mat-drawer-content-smallScreen' : 'mat-drawer-content-largeScreen'">
                <div style="display: flex" class="ContentTitle_ImgText">
                    <div>
                        <img src="./assets/MW_Q_b.png" alt="MagoWeb" style="max-width: 80px" />
                    </div>
                    <div style="margin-left: 2rem; margin-top: 0.6rem">
                        <h2>{{ this.magoWebService?.currentIndustry?.TranslatedName }}</h2>
                    </div>
                </div>
                <br /><br />

                <ms-magoweb-stepper></ms-magoweb-stepper>
            </div>
        </mat-drawer-content>
        <mat-drawer
            mode="side"
            #drawer
            opened
            [position]="this.smallScreen ? 'bottom' : 'end'"
            [ngClass]="this.smallScreen ? 'mat-drawer-smallScreen' : 'mat-drawer-largeScreen'"
        >
            <mat-card class="summuryPriceCard">
                <mat-card-title>
                    <div style="display: flex; justify-content: space-between">
                        <div translate>INDUSTRY_CONFIGURATOR.SUMMARY</div>
                        <div>
                            <button mat-icon-button (click)="show_hide()">
                                <mat-icon>{{ this.magoWebService?.expandSummary ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
                            </button>
                        </div>
                    </div>
                </mat-card-title>

                <mat-card-subtitle *ngIf="this.magoWebService?.expandSummary">
                    <div *ngIf="this.magoWebService?.subscriptionNfs">
                        <div>
                            {{ this.magoWebService?.currentIndustry?.TranslatedName }}<br />
                            <span class="text-smaller" translate>COMMONS.NFS_VERSION</span>
                        </div>
                    </div>
                </mat-card-subtitle>
                <div
                    *ngIf="(this.storeRoleService.IsInternal || this.storeRoleService.isBetaTester) && !this.magoWebService.subscriptionNfs"
                >
                    <button
                        mat-flat-button
                        color="primary"
                        (click)="createOrUpdateTestSubscription()"
                        [disabled]="+this.magoWebService?.totalCalFullNr == 0"
                        [ngClass]="{ disableclick: this.magoWebService?.totalCalFullNr == 0 }"
                    >
                        <span *ngIf="this.subscriptionKey && this.subscriptionKey.length > 0" translate>COMMONS.UPDATE_SUBSCRIPTION</span>
                        <span *ngIf="!this.subscriptionKey || this.subscriptionKey.length == 0" translate>COMMONS.CREATE_SUBSCRIPTION</span>
                    </button>
                </div>

                <div style="display: flex; justify-content: center" *ngIf="this.magoWebService.subscriptionNfs">
                    <button
                        mat-flat-button
                        color="primary"
                        (click)="generateNFSOrder()"
                        [disabled]="this.magoWebService?.disableButton()"
                        [ngClass]="{
                            disableclick: this.magoWebService?.disableButton() || !this.userchecked
                        }"
                    >
                        <span translate *ngIf="!this.magoWebService.isModifyStatus">COMMONS.CREATE_SUBSCRIPTION</span>
                        <span translate *ngIf="this.magoWebService.isModifyStatus">COMMONS.UPDATE_SUBSCRIPTION</span>
                    </button>
                </div>
            </mat-card>
        </mat-drawer>
    </mat-drawer-container>
</div>
<div *ngIf="this.loading">
    <tb-loading></tb-loading>
</div>
